import React from 'react';
import { Navigation } from './Navigation';

export interface HeaderProps {
  /**
   * Currently active section id
   */
  activeSection?: string;
  /**
   * Callback when navigation link is clicked
   */
  onNavigate?: (sectionId: string) => void;
}

/**
 * Header component with logo and navigation.
 *
 * Features:
 * - Displays restaurant logo (LOGO-3D-Transparent.png)
 * - Integrates Navigation component
 * - Sticky header with background on scroll
 * - Responsive logo sizing (mobile/tablet/desktop)
 *
 * Requirements: 1.1, 2.1, 2.3, 2.4, 10.1, 10.2, 10.3
 */
export const Header: React.FC<HeaderProps> = ({ activeSection, onNavigate }) => {

  return (
    <header
      className={[
        'fixed top-0 left-0 right-0 z-50 transition-all duration-300',
        'bg-[#1a1a1a]/95 backdrop-blur-sm shadow-lg',
      ].join(' ')}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20 lg:h-24">
          {/* Logo */}
          <a
            href="#home"
            className={[
              'flex items-center focus:outline-none focus-visible:ring-2',
              'focus-visible:ring-[#c9a84c] focus-visible:ring-offset-2',
              'focus-visible:ring-offset-[#1a1a1a] rounded-lg',
            ].join(' ')}
            aria-label="Restaurant Fey - Zur Startseite"
            onClick={(e) => {
              e.preventDefault();
              const target = document.getElementById('home');
              if (target) {
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
              onNavigate?.('home');
            }}
          >
            <img
              src="/LOGO-3D-Transparent.png"
              alt="Restaurant Fey Logo"
              className={[
                'h-10 w-auto transition-all duration-300',
                'sm:h-12 md:h-14 lg:h-16',
                'object-contain',
              ].join(' ')}
              width={64}
              height={64}
              decoding="async"
            />
          </a>

          {/* Navigation */}
          <Navigation activeSection={activeSection} onNavigate={onNavigate} />
        </div>
      </div>
    </header>
  );
};
